import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const ListingDetailLink = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const getLinkClassName = () => {
        let baseClass = "view-listing-details-link des-view-listingDetails template-branded-button";
        if (props.isAuctionOnToday || props.IsAuctionLive) {
            if (props.IsAT && currentSite?.IsAuctionTimeAuctionSite) {
                baseClass += " at-bid-now-link";
            }
            else if (props.IsEF && currentSite?.IsBidCallerAuctionSite) {
                baseClass += " bc-bid-now-link";
            }
        } else if (props.IsAT) {
            baseClass += " at-view-details"
        }
        if (props.IsPremiumListing) {
            baseClass += "";
        }
        return baseClass;
    };   

    const getDisplayText = () => {
            if (isUpcomingAuction() && (props.IsAuctionLive || props.isAuctionOnToday)) {
                var bidAmount = props.NextBidAmount ? props.NextBidAmount : '';
                return translator.translate('sandhills.tradepubwebsite.mvc.bidnowtext') + ' ' + bidAmount;
            }
   
        return <TranslationText tKey='sandhills.tradepubwebsite.mvc.viewdetails' />;
    };

    const getIconClass = () => {
        if (isUpcomingAuction() && (props.IsAuctionLive || props.isAuctionOnToday)) {
            return "fas fa-gavel";
        }

        return "fas fa-search-plus";
    };

    const isUpcomingAuction = () => {
        return ((props.IsAT && currentSite?.IsAuctionTimeAuctionSite) || (props.IsEF && currentSite?.IsBidCallerAuctionSite)) && !props.IsAuctionResult;
    };

    return (
        <span>
            <a className={getLinkClassName()} href={props.DetailUrl} target={props.openDetailPageInNewTab ? "_blank" : "_self"} >
                <i className={getIconClass()} aria-hidden="true"></i>
                {getDisplayText()}
                {props.openDetailPageInNewTab && <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>}
            </a>
        </span>
        );
}

export default ListingDetailLink;